export default "__VITE_ASSET__CUJMNUDB__"